import { defineStore } from "pinia";
import { FetchRequest } from "../helpers/fetch-request";
import { FileHelper } from "@/helpers/file-helper";

export const useDownloadsStore = defineStore('downloads', {
    state: () => ({
        downloadsReq: new FetchRequest('downloads', 'GET'),
        reviewOpen: false, reviewLoading: false, reviewError: '', reviewSql: '', reviewDownload: null,
        reviewRequest: null, pendingReviewIds: []
    }),
    getters: {
        hasDownloads(state) {
            return state.downloadsReq.hasLoadedData
        },
        downloads(state) {
            return state.downloadsReq.data
        },
    },
    actions: {
        getDownloads() {
            this.downloadsReq.send()
        },
        async downloadExportedSql(download) {
            this.reviewOpen = true
            this.reviewLoading = true
            this.reviewError = ''
            this.reviewSql = ''
            this.reviewDownload = download
            this.reviewRequest = new FetchRequest(`downloads/${download.id}/sql`, 'GET')
            const request = this.reviewRequest
            try {
                const data = await request.send()
                if (this.reviewRequest === request) this.reviewSql = data.sql
            } catch (error) {
                if (this.reviewRequest === request) this.reviewError = String(error)
            } finally {
                if (this.reviewRequest === request) this.reviewLoading = false
            }
        },
        confirmSqlDownload() {
            if (!this.reviewSql || !this.reviewDownload) return
            FileHelper.downloadAsFile([this.reviewSql], `${this.reviewDownload.title}.sql`)
            this.reviewOpen = false
        },
        watchExport(download) {
            const completed = download.file_url ? download : this.downloads.find(item => item.id === download.id && item.file_url)
            if (completed) return this.downloadExportedSql(completed)
            if (!this.pendingReviewIds.includes(download.id)) this.pendingReviewIds.push(download.id)
        },
    }
})
